import { render, staticRenderFns } from "./index.vue?vue&type=template&id=249bd008&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=249bd008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249bd008",
  null
  
)

export default component.exports